<template>
  <div
    v-if="loader === false"
    class="alert-body"
  >
    <b-list-group
      v-if="moduleObject.module_id === 25"
      flush
      class="awaitlist operator-list"
    >
      <!-- <b-list-group-item
        v-if="moduleObject.module_settings.is_timed"
        class="main-items"
      >
        {{ $t('DEBTIA_TIMED') }} : {{ $t('DEBTIA_YES') }}
      </b-list-group-item> -->
      <b-list-group-item
        v-if="moduleObject.module_settings.is_timed && moduleObject.module_settings.days && moduleObject.module_settings.days !== null && moduleObject.module_settings.days !== ''"
        class="main-items"
      >
        {{ $t('DEBTIA_DAYS') }} : {{ moduleObject.module_settings.days }}
      </b-list-group-item>
      <!-- <b-list-group-item
        v-if="!moduleObject.module_settings.is_timed"
        class="main-items"
      >
        {{ $t('DEBTIA_TIMED') }}: {{ $t('DEBTIA_NO') }}
      </b-list-group-item> -->
      <template>
        <b-list-group-item
          v-for="(row, index) in moduleObject.module_settings.rules"
          :key="index"
          class="main-items"
        >
          {{ $t('DEBTIA_FILE_CATEGORIES') }}: {{ row.file_category }}
          | {{ $t('DEBTIA_OPERATOR') }}: {{ row.operator }}
          <!-- | {{ $t('DEBTIA_CUSTOM_FIELD') }}: {{ row.threshold }} -->
          <span>
            | {{ $t('DEBTIA_NUMBER_OF_UPLOADS') }}: {{ row.threshold }}<span v-if="row.value_type === 'custom_variable'"> ({{ $t('DEBTIA_CUSTOM_FIELD') }})</span>
          </span>
          <!-- <span v-if="row.value_type === 'literal'">
            | {{ $t('DEBTIA_NUMBER_OF_DAYS') }}: {{ row.threshold }}
          </span>
          <span v-if="row.value_type === 'custom_variable'">
            | {{ $t('DEBTIA_CUSTOM_VARIABLE') }}: {{ row.threshold }} ({{ $t('DEBTIA_CUSTOM_FIELD') }})
          </span> -->
        </b-list-group-item>
      </template>
    </b-list-group>
    <b-list-group
      v-else-if="moduleObject.module_id !== 17"
      flush
      class="awaitlist operator-list"
    >
      <b-list-group-item
        :id="'condition-statement-22'"
        class="main-items"
      >
        {{ $t('DEBTIA_CONDITION') }} : {{ getConditionStatement(moduleObject.module_settings.condition_id) }}
        <small
          v-if="moduleObject.module_settings.statements"
        >
          ({{ moduleObject.module_settings.statements }})
        </small>
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_id === 14"
        :id="'condition-statement-22'"
        class="main-items"
      >
        {{ $t('DEBTIA_DAYS') }} : {{ moduleObject.module_settings.days }}
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_settings.condition_operator_id < 3"
        :id="'operator-statement-22'"
        class="main-items"
      >
        {{ $t('DEBTIA_OPERATOR') }} : {{ moduleObject.module_settings.condition_operator_id === 1 ? 'True' : 'False' }}
      </b-list-group-item>
      <b-list-group-item
        v-else
        :id="'operator-statement-22'"
        class="main-items"
      >
        {{ $t('DEBTIA_OPERATOR') }} : {{ moduleObject.module_settings.statementOperator }}
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_settings.field"
        :id="'operator-statement-22'"
        class="main-items"
      >
        {{ $t(moduleObject.module_settings.field.label) }} : {{ moduleObject.module_settings.condition_id === 10 ? $t(moduleObject.module_settings.field.value) : moduleObject.module_settings.field.value }}
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_settings.custom_variable_id > 0 && moduleObject.module_settings.custom_variable_value !== null"
        :id="'operator-statement-22'"
        class="main-items"
      >
        {{ $t('DEBTIA_CUSTOM_VARIABLE_VALUE') }} : {{ moduleObject.module_settings.custom_variable_value !== null ? moduleObject.module_settings.date_type === 'dato-felt' ? `+${moduleObject.module_settings.custom_variable_value} dags dato` : moduleObject.module_settings.custom_variable_value : 'N/A' }}
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_settings.client_type"
        class="main-items"
      >
        {{ $t('DEBTIA_CLIENT_TYPE') }} : {{ moduleObject.module_settings.client_type === 'person' ? 'Person' : moduleObject.module_settings.client_type === 'sole-proprietorship' ? $t('DEBTIA_SOLE_PROPRIETORSHIP') : moduleObject.module_settings.client_type === 'capital-company' ? $t('DEBTIA_CAPITAL_COMPANY') : '' }}
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_id === 14"
        class="main-items"
      >
        {{ $t('DEBTIA_AWAIT_SKIP_MONDAY') }} : {{ moduleObject.module_settings.skip_monday ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
      </b-list-group-item>
      <b-list-group-item
        v-if="moduleObject.module_id === 14"
        class="main-items"
      >
        {{ $t('DEBTIA_AWAIT_SKIP_INTEREST') }} : {{ moduleObject.module_settings.skip_interest_calculation ? $t('DEBTIA_YES') : $t('DEBTIA_NO') }}
      </b-list-group-item>
    </b-list-group>
    <b-list-group
      v-else
      flush
      class="awaitlist operator-list"
    >
      <b-list-group-item
        class="main-items"
      >
        Bailiff Conclusion Popup
      </b-list-group-item>
    </b-list-group>
    <b-row
      class="row-yes-no"
    >
      <b-col
        cols="12"
        md="6"
        class="column-no"
      >
        <b-alert
          variant="primary"
          show
        >
          <div>
            <b-list-group
              flush
              class="split-div"
            >
              <b-list-group-item
                class="yes-no"
              >
                {{ moduleObject.module_id !== 17 ? $t('DEBTIA_NO') : $t('DEBTIA_BAILIFF_NO') }}
              </b-list-group-item>
              <b-list-group-item
                class="noBackGround"
              >
                <inner-modules-list
                  :modules-object="noObject"
                  :module-object-id="moduleObject.id"
                  :main-div-id="mainDivId"
                />
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="column-yes"
      >
        <b-alert
          variant="primary"
          show
        >
          <div>
            <b-list-group
              flush
              class="split-div"
            >
              <b-list-group-item
                class="yes-no"
              >
                {{ moduleObject.module_id !== 17 ? $t('DEBTIA_YES') : $t('DEBTIA_BAILIFF_YES') }}
              </b-list-group-item>
              <b-list-group-item
                class="noBackGround"
              >
                <inner-modules-list
                  :modules-object="yesObject"
                  :module-object-id="moduleObject.id"
                  :main-div-id="mainDivId"
                />
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BAlert, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
// import axios from '@axios'
import axios from '@axios'
import InnerModulesList from './InnerModulesList.vue'
// import Ripple from 'vue-ripple-directive'
// import i18n from '@/libs/i18n'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BListGroup,
    BListGroupItem,
    InnerModulesList,
  },
  props: {
    moduleObject: {
      type: Object,
      required: true,
    },
    allModules: {
      type: Array,
      required: true,
    },
    mainDivId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      noObject: [],
      yesObject: [],
      conditionOptions: [],
      loader: true,
    }
  },
  watch: {
    moduleObject: {
      handler() {
        this.refreshcomponent()
      },
    },
    allModules: {
      handler() {
        this.refreshcomponent()
      },
    },
  },
  created() {
    this.refreshcomponent()
    this.getConditions()
  },
  methods: {
    refreshcomponent() {
      this.getNoObject()
      this.getYesObject()
    },
    getNoObject() {
      // console.log('i m triggered ', this.allModules)
      const md = this.allModules
      this.noObject = []
      md.forEach(element => {
        // console.log('md ', element)
        // console.log('this.moduleObject.id ', this.moduleObject.id)
        if (element.condition === 0 && element.depends_on === this.moduleObject.id) {
          // console.log('i am in if')
          this.noObject.push(element)
          // console.log(this.noObject)
        }
      })
    },
    getYesObject() {
      const md = this.allModules
      this.yesObject = []
      md.forEach(element => {
        if (element.condition === 1 && element.depends_on === this.moduleObject.id) {
          this.yesObject.push(element)
        }
      })
    },
    getConditionStatement(id) {
      const conditionTitle = this.conditionOptions.filter(element => element.value === id)
      return this.$t(conditionTitle[0].label)
    },
    async getConditions() {
      this.loader = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          this.conditionOptions.push(...response.data.data.variables)
          this.loader = false
        }
      }).catch(error => console.log(error))
    },
  },
}
</script>

<style lang="scss">
</style>
